import Link from "next/link";
import React from "react";
import ImageTitle from "../../components/imageTitle";
import { help_center_data } from "../../data/help_center_data";
import { accordion_data } from "../../data/help_center_data";
import Accordion from "../../components/accordion";
import Meta from "../../components/Meta";
import Image from "next/image";

import WhiteLogo from "./../../public/images/Ico-LOGO/white.png";

const Faqs = () => {
  const bgImage = "/images/page-title/knowledge_base_banner.jpg";
  return (
    <div>
      <Meta title="FAQS || Impactoverse " />
      <div className="pt-[5.5rem] lg:pt-24">
        {/* <!-- Page Title --> */}
        <section className="relative py-24">
        <div className="container">
          {/* Start global distribute and dao idea */}
          <div className="lg:flex lg:space-x-12">
            <picture className="pointer-events-none absolute inset-0 -z-10 dark:hidden !ml-0">
              <Image
                width={1519}
                height={935}
                src="/images/gradient.jpg"
                alt="gradient"
                className="h-full w-full object-cover"
              />
            </picture>
            <picture className="pointer-events-none absolute inset-0 -z-10 hidden dark:block !ml-0">
              <Image
                width={1519}
                height={935}
                src="/images/gradient_dark.jpg"
                alt="gradient dark"
                className="h-full w-full object-cover"
              />
            </picture>
          </div>
          <div>
            <div className="dark:hidden">
              <Image
                src={WhiteLogo}
                height={42}
                width={195}
                className="mx-auto flex top-0 z-10 bg-blue-500 rounded-md animate-spin-faux3d"
                alt="Impactoverse | Impact Ecosystem"
              />
            </div>
            <div className="hidden dark:block">
              <Image
                src={WhiteLogo}
                height={42}
                width={195}
                className="mx-auto flex top-0 z-10 bg-blue-500 rounded-md animate-spin-faux3d"
                alt="Impactoverse | Impact Ecosystem"
              />
            </div>

            <h1 className="font-display text-3xl text-jacarta-700 dark:text-white lg:text-4xl xl:text-6xl text-center uppercase">
            Frequently Asked  
              <span className="animate-gradient"> Questions</span>
            </h1>
            {/* <p className="text-lg mb-10 dark:text-jacarta-300 text-center">
            Join our community now to get free updates and also alot of freebies are waiting for you Or{' '}
            <br />
				<Link href="/contact" className="text-accent">
					Contact Support
				</Link>
            </p> */}
           
          </div>

        </div>
      </section>

        {/* <ImageTitle text="How can I help you?" image={bgImage} input={true} /> */}

        {/* <!-- Help Center --> */}
        <section className="relative py-24">
         
          <div className="container">
         

            <Accordion data={accordion_data} />
          </div>
        </section>
        {/* <!-- end help center --> */}
      </div>
    </div>
  );
};

export default Faqs;
